import { FC } from "react"

import CustomButtonRight from "../customButtonRight";
import CustomLineChart from "../customLineChart";

import { StatisticsObjectType } from "./types";


const CaseVolume: FC<StatisticsObjectType> = ({ StatisticsObjectType }): JSX.Element => {
  return (
    <div className="row mt-2">
      <div className="col-12 col-sm-12 col-md-9 mb-3 mb-md-0" style={{maxHeight:550}}>
        <CustomLineChart title="Case Volume" LineChartObject={StatisticsObjectType?.case_volume} />
      </div>
      <div className="col-12 col-sm-12 col-md-3 d-flex flex-column flex-fill" style={{maxHeight:550}}>
        {<CustomButtonRight StatisticsObjectType={StatisticsObjectType} />}
      </div>
    </div>
  )
}
export default CaseVolume;

